import { queryOptions } from '@tanstack/react-query'
import goodsApi from 'api/goodsApi'
import _ from 'lodash'

export const goodsQueries = {
  base: {
    scope: ['category', 'goods'],
  },
  listOfGoods: (params) =>
    queryOptions({
      queryKey: [goodsQueries.base, { entity: 'goods' }, params],
      queryFn: ({ signal }) => goodsApi.find(params, signal),
      select: (res) => {
        if (res.result !== 'success') return
        return {
          data: res.goods ?? [],
          total: _.get(res, 'total', 0),
        }
      },
    }),
  dataLogGoods: (params) =>
    queryOptions({
      queryKey: [goodsQueries.base, { entity: 'data-log-goods' }, params],
      queryFn: ({ signal }) => goodsApi.findDataLogGoods(params, signal),
      select: (res) => {
        const { result, metadata } = res
        if (result !== 'success') return
        return _.concat(
          [{ value: null, label: 'Tất cả hàng hóa' }],
          metadata.products ?? [],
        )
      },
    }),
  exportGoods: (params) =>
    queryOptions({
      queryKey: [goodsQueries.base, { entity: 'goods' }, params],
      queryFn: ({ signal }) => goodsApi.exportExcel(params, signal),
      select: (res) => {
        console.log('res', res)
        if (res.result !== 'success') return
        return {
          data: res.goods ?? [],
          total: _.get(res, 'total', 0),
        }
      },
    }),
}
